import _regeneratorRuntime from "@babel/runtime/regenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { TokenHandler, overrideFuncNames } from './token-handler';
import { retryErrors, networkErrors } from './error-codes';

var OSSBase = /*#__PURE__*/function (_TokenHandler) {
  _inherits(OSSBase, _TokenHandler);

  var _super = _createSuper(OSSBase);

  /**
   * 重写oss的所有函数到当前class，调用时触发token获取，自带异常处理重试机制
   * @param options
   */
  function OSSBase(options) {
    var _this;

    _classCallCheck(this, OSSBase);

    _this = _super.call(this, options);
    Object.defineProperties(_assertThisInitialized(_this), overrideFuncNames.reduce(function (descriptorMap, funcName) {
      descriptorMap[funcName] = {
        enumerable: false,
        get: function get() {
          var ossFunc = /*#__PURE__*/function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              var _len,
                  args,
                  _key,
                  retryCount,
                  maybeOptions,
                  clearArgs,
                  instance,
                  _args = arguments;

              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      for (_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = _args[_key];
                      }

                      // eslint-disable-next-line prefer-const
                      retryCount = args[0], maybeOptions = args[1], clearArgs = args.slice(2);

                      if (maybeOptions.skipHandleError === undefined) {
                        clearArgs = [maybeOptions].concat(_toConsumableArray(clearArgs));
                        maybeOptions = undefined;
                      }

                      _context.next = 5;
                      return _this.getClient();

                    case 5:
                      instance = _context.sent;
                      return _context.abrupt("return", instance[funcName].apply(instance, _toConsumableArray(clearArgs))["catch"](_this.xiguaHandleError(ossFunc, clearArgs, maybeOptions, retryCount)));

                    case 7:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));

            return function ossFunc() {
              return _ref.apply(this, arguments);
            };
          }();

          return function () {
            for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }

            return ossFunc.apply(void 0, [0].concat(args));
          };
        }
      };
      return descriptorMap;
    }, {}));
    return _this;
  }

  _createClass(OSSBase, [{
    key: "xiguaHandleError",
    value: function xiguaHandleError(func, args, options, retryCount) {
      var _this2 = this;

      return /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(err) {
          var _this2$options$onErro, _this2$options;

          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!(retryCount === 2)) {
                    _context2.next = 3;
                    break;
                  }

                  if (!options || (options === null || options === void 0 ? void 0 : options.skipHandleError) !== true) {
                    (_this2$options$onErro = (_this2$options = _this2.options).onError) === null || _this2$options$onErro === void 0 ? void 0 : _this2$options$onErro.call(_this2$options, err);
                  }

                  return _context2.abrupt("return", Promise.reject(err));

                case 3:
                  if (!retryErrors.includes(err.code)) {
                    _context2.next = 6;
                    break;
                  }

                  _context2.next = 6;
                  return _this2.getClient(true)["catch"](_this2.options.onError);

                case 6:
                  if (!networkErrors.includes(err.code)) {
                    _context2.next = 9;
                    break;
                  }

                  _context2.next = 9;
                  return new Promise(function (resolve) {
                    return setTimeout(resolve, 1000);
                  });

                case 9:
                  if (options) {
                    args.unshift(options);
                  }

                  return _context2.abrupt("return", func.apply(void 0, [retryCount + 1].concat(_toConsumableArray(args))));

                case 11:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }();
    }
    /**
     * list函数包装版
     * @param dir 要查询的地址
     * @param clear 是否过滤文件夹类型
     */

  }, {
    key: "listDir",
    value: function listDir(dir) {
      var clear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return this.list({
        prefix: dir,
        'max-keys': 100
      }, {}).then(function (_ref3) {
        var objects = _ref3.objects;
        var ossObjs = objects || [];

        if (clear) {
          return ossObjs.filter(function (_ref4) {
            var name = _ref4.name;
            return !name.endsWith('/');
          });
        }

        return ossObjs;
      });
    }
  }]);

  return OSSBase;
}(TokenHandler);

export { OSSBase as default };